import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Sofía', 'Martina', 'Lucía', 'Florencia', 'Camila', 'Valentina', 'Micaela', 'Julieta', 'Agustina', 'Paula', 'Carolina', 'Victoria'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Santa Fe', 'San Juan', 'Resistencia', 'Bahía Blanca', 'Posadas'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerData, setBuyerData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setBuyerData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 10000);
    // Recurring interval (every 15-20 seconds)
    const interval = setInterval(() => {
      showPopup();
    }, 15000 + Math.random() * 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-250">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-gray-100 p-4 pr-10 flex items-start gap-3" data-id="element-251">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-252">
            <X className="w-4 h-4" data-id="element-253" />
          </button>

          <div className="bg-brand-teal/10 p-2 rounded-full flex-shrink-0 mt-0.5" data-id="element-254">
            <span className="text-xl" role="img" aria-label="Celebration" data-id="element-255">
              🎉
            </span>
          </div>

          <div data-id="element-256">
            <p className="text-sm font-medium text-gray-900" data-id="element-257">
              {buyerData.name} de {buyerData.city}
            </p>
            <p className="text-xs text-gray-600 mt-0.5" data-id="element-258">
              acaba de comprar EL ARSENAL DEL NUTRI
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-259">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}